<template>
    <div v-on:click="onClick" :class="{ 'icon-text-checkbox': true, checked: (this.checked), labeled: (!this.nolabel) }">
        <div class="image-wrap"><slot name="image"></slot></div>
        <span v-if="!nolabel"><slot name="label"></slot></span>
    </div>
</template>

<script>
    export default {
        name: "IconTextCheckbox",
        props: ["nolabel", "index", "value"],
        data: function() {
            return {
                checked : false
            }
        },
        mounted: function() {
            this.checked = this.value;
        },
        methods: {
            onClick: function () {
                this.checked = !this.checked;
                this.$emit('input', this.checked);
            }
        },
        watch: {
            value: function () {
                this.checked = this.value;
            }
        }
    }
</script>

<style scoped lang="scss">

</style>